<template>
  <div>
    <div style="width: 95%; height: calc(100%)">
      <!-- <img src="../../assets/dataimage/1.png" style="width:90%" /> -->
      <div
        id="charts_canvas"
        class="echart"
        style="width: 100%; height: 100%"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chartObj: null,
      option: {
        legend: {
          top: "bottom",
        },
        toolbox: {
          show: true,
        },
        grid:{

        },
        series: [
          {
            bottom:"10%",
            name: "学习活动时间分配图",
            type: "pie",
            radius: [10, "80%"],
            center: ["50%", "50%"],
            roseType: "area",
            itemStyle: {
              borderRadius: 8,
            },
            label: {
              show: true,
              position: "inside",
            },
            data: [
              { value: 0, name: "思维网格" },
              { value: 0, name: "思维导图" },
              { value: 0, name: "电子白板" },
              { value: 0, name: "问卷调查" },
              { value: 0, name: "自主学习" },
              { value: 0, name: "其他" },
            ],
          },
        ],
      },
    };
  },
  methods: {
    randomNum(minNum, maxNum) {
      switch (arguments.length) {
        case 1:
          return parseInt(Math.random() * minNum + 1, 10);
          break;
        case 2:
          return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
          break;
        default:
          return 0;
          break;
      }
    },
    setChart() {
      // 雷达图显示的标签
      let newPromise = new Promise((resolve) => {
        resolve();
      });
      //然后异步执行echarts的初始化函数
      newPromise.then(() => {
        const chartObj = this.$echarts.init(
          //劳动课程
          this.$el.querySelector("#charts_canvas")
          //   document.getElementById("#charts_canvas")
        );
        let _array = [];
        for (var i = 0; i < 6; i++) {
          this.option.series[0].data[i].value = this.randomNum(30, 80);
          // _array.push(this.randomNum(0, 80));
        }
        // this.option.series[0].data[0].value = _array;
        // 初始化雷达图
        this.chartObj = chartObj;
        this.chartObj.setOption(this.option);
      });
      let _this = this;
      window.addEventListener("resize", () => {
        if (_this.chartObj) {
          _this.chartObj.resize();
        }
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.setChart();
    });
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/pages/components/report/coursePie.vue